<template>
  <v-app class="custom_phase01">
    <v-main>
      <div v-if="backendVariant" class="backend-variant-indicator">
        test mode
      </div>
      <router-view />
      <common-dialog ref="commonDialog" />
      <commonSnackbar ref="commonSnackbar" />
      <commonLoading ref="commonLoading" :full-view="true" />
      <commonLoading2 ref="commonLoading2" :full-view="true" />
      <commonLoadingLine ref="commonLoadingLine" :full-view="true" />
    </v-main>
  </v-app>
</template>

<script>
import "./assets/css/styles.css";
import SnackBar from "./components/Snackbar.vue";
import Loading from "./components/Loading.vue";
import Loading2 from "./components/Loading_circular01.vue";
import LoadingLine from "./components/Loading_line01.vue";
import Dialog from "./components/Dialog.vue";
import { useAppLabelsStore } from "@/stores/appLabels.js";
import { useUserInfoStore } from "@/stores/userInfo.js";
import { useContractsStore } from "@/stores/contracts.js";
import { useLanguageStore } from "@/stores/language.js";
import { i18n } from "@/main.js";
import { computed } from "vue";
import { getLocalStorageItemCaseInsensitive } from "@/utils/storage.js";

export default {
  name: "App",
  components: {
    CommonSnackbar: SnackBar,
    CommonLoading: Loading,
    CommonLoading2: Loading2,
    CommonLoadingLine: LoadingLine,
    CommonDialog: Dialog,
  },
  data: () => ({
    backendVariant: "",
  }),
  setup() {
    const appLabelsStore = useAppLabelsStore();
    const userInfoStore = useUserInfoStore();
    const contractsStore = useContractsStore();
    const languageStore = useLanguageStore();
    const label_vmanagement_app = computed(() =>
      appLabelsStore.appLabel("label_vmanagement_app"),
    );
    const appEnvName = import.meta.env.MODE;

    return {
      label_vmanagement_app,
      appEnvName,
      appLabels: appLabelsStore,
      userInfo: userInfoStore,
      contracts: contractsStore,
      language: languageStore,
      i18n: i18n,
    };
  },
  watch: {
    label_vmanagement_app: {
      handler: function () {
        document.title = this.getAppTitle();
      },
      // 初回表示時、F5画面更新時に反映させる為即時実行
      immediate: true,
    },
  },
  mounted() {
    this.refreshBackendVariant();
    window.addEventListener("storage", this.refreshBackendVariant);
    window.addEventListener("focus", this.refreshBackendVariant);
  },
  beforeUnmount() {
    window.removeEventListener("storage", this.refreshBackendVariant);
    window.removeEventListener("focus", this.refreshBackendVariant);
  },
  methods: {
    emitMyEvent() {
      this.emitter.emit("UPDATE_USERNAME", { eventContent: "String changed" });
    },
    getAppTitle() {
      if (!this.appEnvName || this.appEnvName === "prod") {
        return this.label_vmanagement_app;
      }
      return `${this.label_vmanagement_app}(${this.appEnvName})`;
    },
    refreshBackendVariant() {
      this.backendVariant =
        getLocalStorageItemCaseInsensitive("X-Backend-Variant");
    },
  },
};
</script>

<style scoped>
.backend-variant-indicator {
  position: fixed;
  bottom: 12px;
  left: 12px;
  z-index: 2000;
  padding: 6px 10px;
  border: 1px solid #8b1e2d;
  border-radius: 999px;
  background: rgba(139, 30, 45, 0.92);
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  pointer-events: none;
}
</style>
